import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalEditPanelNextButtonTooltip = ({
  hasSelectedInvalidApprovers,
  numberOfApprovers,
  numberOfChanges
}) => {
  if (numberOfChanges < 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.tooltipNoChanges"
    });
  }
  if (numberOfApprovers < 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.tooltipNoApprovers"
    });
  }
  if (numberOfApprovers > 10) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.tooltipTooManyApprovers"
    });
  }
  if (hasSelectedInvalidApprovers) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalEditPanel.tooltipInvalidApproverSelected"
    });
  }
  return null;
};
export default ApprovalEditPanelNextButtonTooltip;